import React from 'react';
import { HeartIcon, ShieldIcon, StarIcon, LockIcon, UsersIcon, HandIcon, ZapIcon } from 'lucide-react';
export function Values() {
  const values = [{
    name: 'Compassion',
    icon: <HeartIcon className="h-6 w-6" data-id="element-206" />
  }, {
    name: 'Integrity',
    icon: <ShieldIcon className="h-6 w-6" data-id="element-207" />
  }, {
    name: 'Excellence',
    icon: <StarIcon className="h-6 w-6" data-id="element-208" />
  }, {
    name: 'Confidentiality',
    icon: <LockIcon className="h-6 w-6" data-id="element-209" />
  }, {
    name: 'Professionalism',
    icon: <ZapIcon className="h-6 w-6" data-id="element-210" />
  }, {
    name: 'Respect',
    icon: <UsersIcon className="h-6 w-6" data-id="element-211" />
  }, {
    name: 'Empowerment',
    icon: <HandIcon className="h-6 w-6" data-id="element-212" />
  }];
  return <section className="py-24 bg-brand-navy text-white" data-id="element-213">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-214">
        <div className="text-center mb-16" data-id="element-215">
          <h2 className="text-brand-red font-bold tracking-wider uppercase text-sm mb-4" data-id="element-216">
            Our Foundation
          </h2>
          <h3 className="text-3xl lg:text-4xl font-bold" data-id="element-217">
            Core Values That Guide Us
          </h3>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-8" data-id="element-218">
          {values.map(value => <div key={value.name} className="flex flex-col items-center text-center group" data-id="element-219">
              <div className="w-16 h-16 rounded-full bg-white/10 flex items-center justify-center mb-4 group-hover:bg-brand-red transition-colors" data-id="element-220">
                {value.icon}
              </div>
              <span className="font-semibold text-sm tracking-wide" data-id="element-221">
                {value.name}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}